import { create } from 'zustand';


const DEFAULT_FEATURES = {
  messaging: true, payments: true, teacher_blogs: true,
  instagram: true, quizzes: true, assignments: true,
};

const useTenantStore = create((set, get) => ({
  school: null,
  features: DEFAULT_FEATURES,
  setResolution: (resolution) => set({
    school: resolution?.school || null,
    features: { ...DEFAULT_FEATURES, ...(resolution?.school?.features || {}) },
  }),
  isFeatureEnabled: (feature) => get().features[feature] !== false,
}));

export default useTenantStore;
